import { Component, computed, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { mgcIconDownRegular, mgcIconListCheck3Regular } from '@sb/mgc-icons';
import { ButtonComponent, DropdownModule, IconComponent, IconRegistry } from '@sb/ui';

import { ReportFilters } from '../../+authenticated/+reports/shared/report-filters/report-filter.interfaces';

interface RadioGroup {
  groupLabel: string;
  groupId: string;
  formControl: FormControl;
  options: {
    key: string;
    value: string;
  }[];
}

@Component({
  standalone: true,
  imports: [DropdownModule, IconComponent, TranslateModule, ButtonComponent, ReactiveFormsModule],
  selector: 'report-filter-groupby',
  templateUrl: './report-filter-groupby.component.html',
})
export class ReportFilterGroupbyComponent {
  public groupByLocation = input.required<FormControl>();
  public groupByLocationWithTeam = input.required<FormControl>();
  public groupByPeriod = input.required<FormControl>();
  public groupDayStats = input.required<FormControl>();

  // TODO: this is an input rather than some import because the report filters component that composes this, is currently responsible for translations
  public readonly reportFilters = input.required<ReportFilters>();

  public readonly radioGroups = computed(() => this.buildRadioGroups());

  public constructor(
    private iconRegistry: IconRegistry,
    private translate: TranslateService,
  ) {
    this.iconRegistry.registerIcons([mgcIconListCheck3Regular, mgcIconDownRegular]);
  }

  private buildRadioGroups(): RadioGroup[] {
    const radioGroups = [];

    if (this.groupByLocation().enabled) {
      radioGroups.push({
        groupLabel: this.translate.instant('Location'),
        groupId: 'groupByLocation',
        formControl: this.groupByLocation(),
        options: this.reportFilters().groupByLocation.options,
      });
    }

    if (this.groupByLocationWithTeam().enabled) {
      radioGroups.push({
        groupLabel: this.translate.instant('Location'),
        groupId: 'groupByLocationWithTeam',
        formControl: this.groupByLocationWithTeam(),
        options: this.reportFilters().groupByLocationWithTeam.options,
      });
    }

    if (this.groupByPeriod().enabled) {
      radioGroups.push({
        groupLabel: this.translate.instant('Period'),
        groupId: 'groupByPeriod',
        formControl: this.groupByPeriod(),
        options: this.reportFilters().groupByPeriod.options,
      });
    }

    if (this.groupDayStats().enabled) {
      radioGroups.push({
        groupLabel: this.translate.instant('Period'),
        groupId: 'groupDayStats',
        formControl: this.groupDayStats(),
        options: this.reportFilters().groupDayStats.options,
      });
    }

    return radioGroups;
  }
}
